import { isInSltApp } from '@/libs/utils';
import LeftArrow from 'icons/black.svg';
import { useEffect, useState } from 'react';
import { cls } from 'reactutils';

export default function NavBar({
  back,
  hideBack,
  text,
  rightComp,
  styles,
}: {
  back?: Function;
  hideBack?: boolean;
  text?: string;
  rightComp?: any;
  styles?: any;
}) {
  const [showRightComp, setShowRightComp] = useState(true);

  useEffect(() => {
    setShowRightComp(!isInSltApp(navigator.userAgent));
  }, []);

  const navBack = () => {
    if (typeof back === 'function') {
      back();
    } else {
      history.back();
    }
  };
  return (
    <>
      <div className="container" style={styles}>
        {!hideBack && (
          <div className="back-box" onClick={navBack}>
            <LeftArrow />
          </div>
        )}
        <div className="name">{text}</div>

        {showRightComp && rightComp && <div className={cls('rightComp')}>{rightComp}</div>}
      </div>
      <style jsx>{`
        .container {
          display: flex;
          background-color: #fff;
          height: 40px;
          border-bottom: 1px solid #ddd;
          position: relative;
          align-items: center;
          flex-shrink: 0;
        }
        .back-box {
          position: absolute;
          bottom: 0;
          top: 0;
          left: 16px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
        .back-box :global(svg) {
          height: 14px;
        }
        .name {
          flex: 1;
          text-align: center;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
        }

        .rightComp {
          position: absolute;
          bottom: 0;
          top: 4px;
          right: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </>
  );
}
